import { useState, useEffect } from "react";
import { SERVER_HOST } from "../utils/constants";
import md5 from "../utils/md5";
import packageJson from "../../package.json";

export default function LoginForm() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [usernames, setUsernames] = useState([]);

    useEffect(() => {
        const fetchUsernames = async () => {
            try {
                const response = await fetch(
                    SERVER_HOST + "?action=get_usernames"
                );
                const data = await response.json();

                if (data.status === "success") {
                    setUsernames(data.data.map((item) => item.name));
                } else {
                    setError("Помилка завантаження користувачів!");
                }
            } catch (error) {
                setError("Помилка завантаження користувачів!");
            }
        };

        fetchUsernames();
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(SERVER_HOST, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    action: "login",
                    username: username,
                    password: md5(password),
                }),
            });

            const data = await response.json();

            if (data.status === "success") {
                window.location.reload();
            } else {
                setError(data.message);
            }
        } catch (error) {
            setError("An error occurred during login!");
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="card login--form--container">
                {error && (
                    <div className="alert alert-danger rounded-5 mt-3 mx-3 mb-0">
                        {error}
                    </div>
                )}

                <div className="mx-2 mt-4 row">
                    <div className="col-4 mt-0">
                        <div className="login--logo--img"></div>
                    </div>
                    <div className="col-8 mt-1">
                        <p className="h6 fw-bold">Шеф</p>
                        <p className="small">
                            {`Версія: ${packageJson.version}`} <br />
                        </p>
                    </div>
                </div>

                <form onSubmit={handleLogin} className="mx-4">
                    <div className="row mb-2 d-flex align-items-center">
                        <label className="col-4 ps-2 pe-0">Користувач:</label>
                        <div className="col-8 ps-1 pe-2">
                            <select
                                className="w-100 form-select rounded-5"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            >
                                <option value="" disabled>
                                    Виберіть користувача
                                </option>
                                {usernames.map((user, index) => (
                                    <option key={index} value={user}>
                                        {user}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row mb-2 d-flex align-items-center">
                        <label className="col-4 ps-2 pe-0">Пароль:</label>
                        <div className="col-8 ps-1 pe-2">
                            <input
                                type="password"
                                className="w-100 form-control rounded-5"
                                placeholder="Введіть пароль"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <div className="row d-flex justify-content-center mb-2">
                        <button
                            type="submit"
                            className="btn btn-sm main--button w-25 fw-bold my-3"
                        >
                            OK
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
